























import { Observer } from "mobx-vue";
import { Component, Vue } from "vue-property-decorator";
import mapStore from "@/store/mapStore";
import formatDistanceToNow from "date-fns/formatDistanceToNow";

@Observer
@Component
export default class TruckSummary extends Vue {
  mapStore = mapStore;
  formatDistanceToNow = formatDistanceToNow;
}
